<template>
    <div class="lite-design-list">
        <div v-show="false">{{update}}</div>
        <div v-for="(design, designID, index) in designList" class="lite-design-card"
             @click="selectDesign(designID)"
             @dblclick="openDesign(designID)">
            <div class="lite-design-card-text" :class="{'lite-active-design': designID === idActiveDesign}">
<!--                Вариант {{$route.params.designID}}-->
                {{design.designName}}
            </div>
            <img class="lite-design-card-img" :src="getDesignPhoto(designID)"
                 @error="imageLoadError(designID)"/>
        </div>
    </div>
</template>

<script>
    import {imgIsLoading} from "../../../ImgIsLoading";
    import {renderDesign} from "../../../../fabric/libs/renderDesign";
    import {imgIsLoadingWhite} from "../../../ImgIsLoadingWhite";

    export default {
        name: "DesignList",
            data(){
                return {
                    photosLoadingInProgress: false,
                    designRenderDataURL: {},
                    update: false,
                    attempts: {}
                }
            },
        props: [
            "isLite"
        ],
        computed: {
            lengthUploadedPhotos(){
                return this.$store.getters["resultImg/LENGTH_UPLOADED_PHOTOS"];
            },
            designList() {
                return this.$store.getters['active/ALL_DESIGNS'];
            },
            idActiveDesign() {
                return this.$store.state.route.params.designID;
            }
        },
        methods: {
            getDesignPhoto(designID) {
                if(this.designRenderDataURL[designID])
                    return this.designRenderDataURL[designID];

                this.designRenderDataURL[designID] = imgIsLoading;
                new renderDesign(
                    designID,
                    this.$store.state.route.params.photoID,
                    true
                ).then((src)=>{
                    this.designRenderDataURL[designID] = this.$store.getters[`projectConfiguration/GENERATE_URL`](src);
                    this.attempts[designID] = 1;
                    this.update = !this.update;
                })

                return this.designRenderDataURL[designID];
            },
            selectDesign(designID) {
                this.$emit('selectDesign', designID);
            },
            openDesign(designID) {
                if (!this.isLite) {
                    this.$emit('openDesign', designID);
                }
            },
            imageLoadError (designID) {
                console.warn("Ошибка зигрузки изображения, повтор");
                if (this.attempts[designID] > 3)
                    console.err("Достигнут предел попыток загрузки изображения");
                this.attempts[designID]+=1;
                let src = this.designRenderDataURL[designID];
                this.designRenderDataURL[designID] = imgIsLoading;
                this.update = !this.update;

                setTimeout(()=>{
                    this.designRenderDataURL[designID] = src;
                    this.update = !this.update;
                }, 1000)

            },
        },
        mounted() {

        },
        updated() {

        }
    }
</script>

<style scoped>
    .lite-design-card {
        display: grid;
        grid-template-columns: 278px;
        grid-template-rows: max-content 150px;
        cursor: pointer;
        transition: box-shadow 0.3s ease;
    }
    .lite-design-card:hover {
        box-shadow: 0 0.6rem 1.1rem rgba(0, 0, 0, 0.15);
    }
    .lite-design-list {
        display: grid;
        grid-auto-flow: row dense;
        grid-row-gap: 20px;
    }
    .lite-design-card-text {
        color: white;
        padding: 10px;
        display: block;
        box-sizing: border-box;
        background-color: #383838;
        text-align: center;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        transition: color 0.3s ease;
        font-size: 14px;
    }
    .lite-design-card-img {
        display: flex;
        object-fit: cover;
        width: 100%;
        height: 100%;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        background-color: #f0f0f0;
    }
    .lite-active-design {
        background-color: #c53a3c;
    }


    .active-design {
        /*border: 2px solid #d83336 !important;*/
    }
    .sidebar-project-img {
        width: 100%;
        border-radius: 2px;
        border: 2px solid white;
        box-sizing: border-box;
        cursor: pointer;
    }
    .sidebar-project-img:hover {
        border: 2px solid #ACACAC;
    }
    .sidebar-project-img:active {
        border: 2px solid #d83336;
    }
    .sidebar-photo-checkbox {
        right: -253px;
        top: 25px;
    }
</style>
